import React, { useEffect } from 'react';

export default function Careers() {
  useEffect(() => {
    document.title = 'Jobs & Collaborations | Nalexus Technologies';
    window.location.replace('/jobs/');
  }, []);

  return (
    <main id="main-content" className="sync-main sync-subpage">
      <section className="sync-page-hero sync-section">
        <div className="sync-shell sync-page-hero-grid">
          <div>
            <p className="sync-eyebrow">Jobs & collaborations</p>
            <h1>Opening the structured application form…</h1>
          </div>
          <div>
            <p className="sync-lead">If you are not redirected, open the jobs and collaborations page below.</p>
            <a className="sync-text-link" href="/jobs/">Open applications <span aria-hidden="true">→</span></a>
          </div>
        </div>
      </section>
    </main>
  );
}
